export interface SseEvent {
  event: string;
  data: string;
}

/**
 * Parses a complete SSE event block into event name and data payload.
 */
export function parseSseBlock(block: string): SseEvent | null {
  const lines = block.split("\n");
  let event = "message";
  const dataLines: string[] = [];

  for (const line of lines) {
    if (line.startsWith("event:"))
      event = line.slice("event:".length).trim();
    else if (line.startsWith("data:"))
      dataLines.push(line.slice("data:".length).trim());
  }

  if (dataLines.length === 0)
    return null;

  return { event, data: dataLines.join("\n") };
}

/**
 * Reads an SSE stream and invokes the handler for each parsed event.
 */
export async function readSseStream(
  response: Response,
  onEvent: (event: SseEvent) => void,
  signal?: AbortSignal,
): Promise<void> {
  if (response.body === null)
    throw new Error("SSE-responsen mangler innhold.");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (!signal?.aborted) {
      const { done, value } = await reader.read();
      if (done)
        break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() ?? "";
      for (const part of parts) {
        const parsed = parseSseBlock(part);
        if (parsed !== null)
          onEvent(parsed);
      }
    }
  } finally {
    reader.releaseLock();
  }
}
